import { Button } from "@/components/ui/button"
import { ArrowRight } from "lucide-react"

interface StepNavigationProps {
  currentStep: number;
  totalSteps: number;
  onNext: () => void;
  isLastStep?: boolean;
}

export const StepNavigation = ({ 
  currentStep, 
  totalSteps, 
  onNext,
  isLastStep = false 
}: StepNavigationProps) => {
  return (
    <div className="flex justify-between items-center">
      <div className="text-sm text-gray-500">
        Step {currentStep + 1} of {totalSteps}
      </div>
      <Button 
        onClick={onNext}
        className="bg-primary hover:bg-primary/90"
      >
        {isLastStep ? (
          'Preview Prompt'
        ) : (
          <>
            Next
            <ArrowRight className="ml-2 h-4 w-4" />
          </>
        )}
      </Button>
    </div>
  )
}